/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useEffect, useMemo, useState } from 'react';
import {
  Box,
  Button,
  Grid as MuiGrid,
  Paper,
  TextField,
  Typography,
} from '@material-ui/core';
import BeachAccessIcon from '@material-ui/icons/BeachAccess';
import AutoFieldLocal from '../components/fields/AutoFieldLocal';
import CalenderLocal from '../components/fields/CalenderLocal';
import { AlertLocal } from '../components';
import { errorAlert, successAlert } from '../Shared/helpers';
import { useEmployees } from '../hooks';

const startOfDay = (value: any) => {
  const dt = new Date(value || new Date());
  dt.setHours(0, 0, 0, 0);
  return dt;
};

const endOfDay = (value: any) => {
  const dt = new Date(value || new Date());
  dt.setHours(23, 59, 59, 999);
  return dt;
};

const getVacationStatus = (startDate: Date, endDate: Date) => {
  const now = new Date();
  if (now >= startDate && now <= endDate) {
    return 2; // active
  }
  return 10; // not active
};

const calcDays = (startDate: Date, endDate: Date) => {
  const start = startOfDay(startDate).getTime();
  const end = startOfDay(endDate).getTime();
  if (end < start) {
    return 0;
  }
  return Math.floor((end - start) / (24 * 60 * 60 * 1000)) + 1;
};

const PopupVacation = ({
  open,
  onClose,
  row,
  addAction,
  editAction,
  isRTL,
  words,
  user,
  isNew,
}: any) => {
  const { employeesfull } = useEmployees();

  const [selectedEmployee, setSelectedEmployee] = useState<any>(null);
  const [startDate, setStartDate] = useState<Date>(startOfDay(new Date()));
  const [endDate, setEndDate] = useState<Date>(endOfDay(new Date()));
  const [desc, setDesc] = useState('');
  const [saving, setSaving] = useState(false);
  const [alrt, setAlrt] = useState({ show: false, msg: '', type: undefined });

  const employeeOptions = useMemo(() => {
    const currentId = selectedEmployee?._id;
    return (employeesfull || []).filter(
      (emp: any) => !emp.disabled || emp._id === currentId,
    );
  }, [employeesfull, selectedEmployee]);

  useEffect(() => {
    if (!open) {
      return;
    }

    if (!isNew && row) {
      const foundEmployee = (employeesfull || []).find(
        (emp: any) => emp._id === row.employeeId,
      );
      setSelectedEmployee(
        foundEmployee || {
          _id: row.employeeId,
          name: row.employeeName,
          nameAr: row.employeeNameAr,
        },
      );
      setStartDate(startOfDay(row.startDate || row.time || new Date()));
      setEndDate(endOfDay(row.endDate || row.time || new Date()));
      setDesc(row.desc || row.note || '');
    } else {
      resetForm();
    }
  }, [open, row, isNew, employeesfull]);

  const resetForm = () => {
    setSelectedEmployee(null);
    setStartDate(startOfDay(new Date()));
    setEndDate(endOfDay(new Date()));
    setDesc('');
    setAlrt({ show: false, msg: '', type: undefined });
  };

  const onFormClose = () => {
    onClose();
    resetForm();
  };

  const handleSaveVacation = async () => {
    if (!selectedEmployee?._id) {
      errorAlert(setAlrt, isRTL);
      return;
    }

    const normalizedStart = startOfDay(startDate);
    const normalizedEnd = endOfDay(endDate);

    if (normalizedEnd < normalizedStart) {
      errorAlert(setAlrt, isRTL);
      return;
    }

    setSaving(true);
    try {
      const variables = {
        ...(isNew ? {} : { _id: row?._id }),
        time: normalizedStart,
        title: isRTL ? 'اجازة موظف' : 'Employee Vacation',
        desc,
        employeeId: selectedEmployee._id,
        employeeName: selectedEmployee.name,
        employeeNameAr: selectedEmployee.nameAr,
        startDate: normalizedStart,
        endDate: normalizedEnd,
        status: getVacationStatus(normalizedStart, normalizedEnd),
        note: desc,
        userId: user?._id,
      };

      const mutate = isNew ? addAction : editAction;
      const mutateName = isNew ? 'createVacation' : 'updateVacation';
      const res = await mutate({ variables });

      if (res?.data?.[mutateName]?.ok) {
        successAlert(setAlrt, isRTL);
        onFormClose();
      } else {
        errorAlert(setAlrt, isRTL);
      }
    } catch (error) {
      console.log(error);
      errorAlert(setAlrt, isRTL);
    }
    setSaving(false);
  };

  if (!open) return null;

  return (
    <Box
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
      }}
    >
      <Paper
        elevation={3}
        style={{
          padding: 30,
          maxWidth: 700,
          width: '92%',
          maxHeight: '90vh',
          overflow: 'auto',
          borderRadius: 15,
        }}
      >
        <Typography
          variant="h5"
          style={{
            fontWeight: 'bold',
            marginBottom: 24,
            textAlign: 'center',
          }}
        >
          {isRTL ? 'نموذج اجازة موظف' : 'Employee Vacation Form'}
        </Typography>

        <MuiGrid container spacing={3}>
          <MuiGrid item xs={12}>
            <AutoFieldLocal
              name="employee"
              title={words?.employee || (isRTL ? 'الموظف' : 'Employee')}
              words={words}
              options={employeeOptions}
              value={selectedEmployee}
              setSelectValue={setSelectedEmployee}
              isRTL={isRTL}
              fullWidth
              mb={0}
            ></AutoFieldLocal>
          </MuiGrid>

          <MuiGrid item xs={12} md={6}>
            <CalenderLocal
              label={isRTL ? 'تاريخ بداية الاجازة' : 'Vacation Start Date'}
              value={startDate}
              onChange={(date: any) => setStartDate(startOfDay(date))}
              format="dd/MM/yyyy"
              isRTL={isRTL}
            />
          </MuiGrid>

          <MuiGrid item xs={12} md={6}>
            <CalenderLocal
              label={isRTL ? 'تاريخ نهاية الاجازة' : 'Vacation End Date'}
              value={endDate}
              onChange={(date: any) => setEndDate(endOfDay(date))}
              format="dd/MM/yyyy"
              isRTL={isRTL}
            />
          </MuiGrid>

          <MuiGrid item xs={12}>
            <TextField
              fullWidth
              variant="outlined"
              label={isRTL ? 'مدة الاجازة (يوم)' : 'Vacation Duration (Days)'}
              value={calcDays(startDate, endDate)}
              disabled
            />
          </MuiGrid>

          <MuiGrid item xs={12}>
            <TextField
              fullWidth
              multiline
              rows={4}
              variant="outlined"
              label={
                isRTL ? 'سبب الاجازة / ملاحظات' : 'Vacation Reason / Notes'
              }
              value={desc}
              onChange={(e) => setDesc(e.target.value)}
            />
          </MuiGrid>

          <MuiGrid item xs={12}>
            <Box
              display="flex"
              justifyContent="center"
              style={{ gap: 16, marginTop: 10 }}
            >
              <Button
                variant="contained"
                color="primary"
                size="large"
                startIcon={<BeachAccessIcon />}
                onClick={handleSaveVacation}
                disabled={!selectedEmployee || saving}
                style={{ minWidth: 180 }}
              >
                {saving
                  ? isRTL
                    ? 'جاري الحفظ...'
                    : 'Saving...'
                  : isRTL
                    ? 'حفظ الاجازة'
                    : 'Save Vacation'}
              </Button>
              <Button
                variant="outlined"
                size="large"
                onClick={onFormClose}
                style={{ minWidth: 120 }}
              >
                {isRTL ? 'إلغاء' : 'Cancel'}
              </Button>
            </Box>
          </MuiGrid>
        </MuiGrid>

        {alrt.show && (
          <AlertLocal
            isRTL={isRTL}
            type={alrt?.type}
            msg={alrt?.msg}
            top={-100}
          />
        )}
      </Paper>
    </Box>
  );
};

export default PopupVacation;
